const DAY_NAMES = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];
const DAY = 86400000;
const iso = date => date.toISOString().slice(0, 10);

export function isoWeek(value) {
  const date = new Date(`${value}T00:00:00Z`);
  const thursday = new Date(date);
  thursday.setUTCDate(date.getUTCDate() + 3 - ((date.getUTCDay() + 6) % 7));
  const firstThursday = new Date(Date.UTC(thursday.getUTCFullYear(), 0, 4));
  firstThursday.setUTCDate(firstThursday.getUTCDate() + 3 - ((firstThursday.getUTCDay() + 6) % 7));
  return { year: thursday.getUTCFullYear(), week: 1 + Math.round((thursday - firstThursday) / (7 * DAY)) };
}

export function fiscalWeeks(period) {
  const first = new Date(`${period.from}T00:00:00Z`);
  first.setUTCDate(first.getUTCDate() - ((first.getUTCDay() + 6) % 7));
  const last = new Date(`${period.to}T00:00:00Z`);
  const weeks = [];
  for (const cursor = first; cursor <= last; cursor.setUTCDate(cursor.getUTCDate() + 7)) {
    const from = iso(cursor), to = iso(new Date(cursor.valueOf() + 6 * DAY));
    const kw = isoWeek(from);
    weeks.push({ from, to, label: `KW ${String(kw.week).padStart(2, "0")}`, isoYear: kw.year,
      partial: from < period.from || to > period.to });
  }
  return weeks;
}

export function calendarDays(period, holidays = []) {
  const holidayByDate = Object.fromEntries(holidays.map(item => [item.datum, item]));
  const days = [];
  const cursor = new Date(`${period.from}T00:00:00Z`);
  const end = new Date(`${period.to}T00:00:00Z`);
  while (cursor <= end) {
    const datum = cursor.toISOString().slice(0, 10);
    days.push({ datum, dayName: DAY_NAMES[cursor.getUTCDay()], weekend: [0, 6].includes(cursor.getUTCDay()), holiday: holidayByDate[datum] });
    cursor.setUTCDate(cursor.getUTCDate() + 1);
  }
  return days;
}

/** Groups a calendar month into ISO weeks running Monday through Sunday.
 * Empty leading and trailing cells intentionally stay outside the selectable
 * month so that the planning query and the visible interaction range agree.
 */
export function monthCalendarWeeks(period, holidays = []) {
  const days = calendarDays(period, holidays);
  if (!days.length) return [];
  const first = new Date(`${days[0].datum}T00:00:00Z`);
  const leading = (first.getUTCDay() + 6) % 7;
  const cells = [...Array(leading).fill(null), ...days];
  while (cells.length % 7) cells.push(null);
  return Array.from({ length: cells.length / 7 }, (_, index) => {
    const weekDays = cells.slice(index * 7, index * 7 + 7);
    const anchor = weekDays.find(Boolean);
    const week = isoWeek(anchor.datum);
    return {
      label: `KW ${String(week.week).padStart(2, "0")}`,
      isoYear: week.year,
      days: weekDays,
    };
  });
}

export function calendarRows({ employees, entries, absences, holidays, period, employeeId }) {
  const days = calendarDays(period);
  const holidayByDate = Object.fromEntries(holidays.map(item => [item.datum, item]));
  return employees.filter(employee => !employeeId || employee.id === employeeId).map(employee => ({
    employee,
    total: entries.filter(item => item.mitarbeiterId === employee.id).reduce((sum, item) => sum + item.stunden, 0),
    days: days.map(day => ({ ...day, holiday: holidayByDate[day.datum],
      absent: absences.some(item => item.mitarbeiterId === employee.id && item.von <= day.datum && item.bis >= day.datum),
      entries: entries.filter(item => item.mitarbeiterId === employee.id && item.datum === day.datum) })),
  }));
}

export function planningMoveBody(entry, mitarbeiterId, datum) {
  return {
    mitarbeiterId,
    datum,
    mandatId: entry.mandatId,
    stunden: entry.stunden,
    ...(entry.halbtag ? { halbtag: entry.halbtag } : {}),
    phaseId: entry.phaseId,
    dispositionsstatusId: entry.dispositionsstatusId,
    inhouseExtern: entry.inhouseExtern,
    kommentar: entry.kommentar || null,
    version: entry.version,
  };
}
